import { assertResponse } from '@/api/assert-response.ts';
import { handleError } from '@/api/handle-error';
import { handleSuccess } from '@/api/handle-success';
import { CONFIG } from '@/config';
import { getCurrentMobileRouteContext } from '@/config/tenant-route';
import {
  cacheInterceptor,
  cancellationInterceptor,
  cancelRequest,
  downloadInterceptor,
  errorInterceptor,
  loadingInterceptor,
  normalizeAxios,
  requestDataInterceptor,
  responseDataInterceptor,
  successInterceptor,
  uploadInterceptor,
} from '@ts-max/axios';
import { Api } from '@ts-max/car-export-api-sdk';
import type { AxiosRequestConfig } from 'axios';

export const apiSdk = new Api({
  baseURL: CONFIG.baseUrl,
  checkDateTimeObject: false,
});

const instance = apiSdk.instance;

instance.interceptors.request.use((config: AxiosRequestConfig) => {
  if (!config.headers) config.headers = {};
  const { locale, tenantCode } = getCurrentMobileRouteContext();
  if (tenantCode) config.headers['x-tenant-code'] = tenantCode;
  else delete config.headers['x-tenant-code'];
  config.headers['X-Locale'] = locale;
  return config as any;
});

// 请求拦截 先注册，后执行 (cancellationInterceptor 应最先注册)
cancellationInterceptor.request(instance);
requestDataInterceptor.request(instance);
loadingInterceptor.request(instance);
uploadInterceptor.request(instance);
downloadInterceptor.request(instance);
cacheInterceptor.request(instance); // 最后注册 → 最先执行，命中时替换 adapter 跳过真实请求

// 响应拦截 先注册，先执行 (cancellationInterceptor 应最先注册)
cancellationInterceptor.response(instance);
downloadInterceptor.response(instance);
loadingInterceptor.response(instance);
cacheInterceptor.response(instance); // 在 responseDataInterceptor 之前，缓存原始响应
responseDataInterceptor.response(instance, { assertResponse });
successInterceptor.response(instance, { handleSuccess });
errorInterceptor.response(instance, { handleError });

export const ajax = normalizeAxios(instance);
export { cacheInterceptor, cancelRequest }; // 导出 cancelRequest
